import Vue from 'vue';
import {LANGUAGES} from '@/const';
import dayjs from 'dayjs';
import * as MUTATIONS from '../mutationTypes';
import {createColorVariables} from '@/utils/colorScheme';
import GoogleAnalytics from '@/components/base-components/Analytics/GoogleAnalytics';
import {SLIDES_TYPES, URL_QUERIES} from '@/const';
import VisaicV3Analytics from '@/components/base-components/Analytics/VisaicV3Analytics';
import {generateIdsObj} from '@/utils/helpers';
import {injectCustomHeadTags} from '@/utils/injectCustomHeadTags';

export default {
  [MUTATIONS.UPDATE_CHANNEL_SETTINGS](state, data) {
    state.settings = data;
    !Vue.$storage.get('interface_language') &&
      this.commit(MUTATIONS.UPDATE_INTERFACE_LANGUAGE, data.language);
    if (data?.['google-analytics']?.['google-tag']) {
      GoogleAnalytics.trackingId = data?.['google-analytics']?.['google-tag'];
      GoogleAnalytics.currency = data?.currency;
    }
    if (data?.['yare-analytics']?.['yare-analytics-key']) {
      VisaicV3Analytics.profileHash = data?.['yare-analytics']?.['yare-analytics-key'];
    }
    injectCustomHeadTags(data?.google_ads?.['custom-head-tags']);
  },
  [MUTATIONS.UPDATE_INTERFACE_LANGUAGE](state, lang) {
    if (LANGUAGES[lang] && lang !== Vue.i18n.locale()) {
      Vue.i18n.add(lang, LANGUAGES[lang]);
      Vue.i18n.set(lang);
      Vue.$storage.set('interface_language', lang);
      import(`dayjs/locale/${lang}.js`).then(() => {
        dayjs.locale(lang);
      });
    }
  },

  [MUTATIONS.UPDATE_CHANNEL_COLORS](state, data) {
    createColorVariables(data || {});
  },

  [MUTATIONS.UPDATE_CHANNEL_MENU](state, data) {
    state.menu = data || [];
  },
  [MUTATIONS.UPDATE_GROUP_MENU](state, groupsList) {
    const menu = [];
    Object.values(generateIdsObj(groupsList || [])).forEach((group) => {
      menu.push({
        name: group.name,
        custom_icon: group.image,
        id: group.id,
        alias: group.alias,
        url: `/?${URL_QUERIES.participantGroup}=${group.alias || group.name}`,
      });
    });
    state.groupMenu = menu;
  },
  [MUTATIONS.UPDATE_PARTICIPANT_MENU](state, participantList) {
    const menu = [];
    participantList.forEach((team) => {
      team.is_displayable && menu.push({
        name: team.name,
        custom_icon: team.images,
        id: team.id,
        alias: team.alias,
        url: `/?${URL_QUERIES.PARTICIPANT}=${team.alias || team.name}`,
      });
    });
    state.participantMenu = menu;
  },
  [MUTATIONS.UPDATE_MAIN_CHANNEL_SLIDES](state, data) {
    data?.forEach((slide) => {
      if (slide.slidable_type) {
        if (!state.slides[slide.slidable_type][slide.slidable_id]) {
          state.slides[slide.slidable_type][slide.slidable_id] = [];
        }

        state.slides[slide.slidable_type][slide.slidable_id].push(slide);
      } else {
        state.slides[SLIDES_TYPES.main].push(slide);
      }
    });
  },
  [MUTATIONS.UPDATE_CHANNEL_PAGES](state, data) {
    state.pages = data || [];
  },
  [MUTATIONS.UPDATE_EVENTS_LOCATIONS](state, data) {
    state.eventLocations = data || [];
  },
  [MUTATIONS.UPDATE_STATIC_BLOCKS](state, data) {
    state.staticBlocks = data || {};
  },
  [MUTATIONS.UPDATE_ATTRIBUTES](state, data) {
    state.attributes = data || [];
  },
  [MUTATIONS.UPDATE_UI_BLOCKS](state, blocks) {
    state.ui.homePage = blocks.homePage || [];
    state.ui.passesPage = blocks.passesPage || {};
    state.ui.scheduleFilters = blocks.scheduleFilters || [];
  },
};
